// components/PermissionDenied.js
import { Button, Card, CardContent, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const PermissionDenied = () => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh",
      background: "#f9fafb"
    }}>
      <Card
        sx={{
          maxWidth: 400,
          p: 3,
          textAlign: "center",
          borderRadius: "1rem",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
        }}
      >
        <CardContent>
          <LockOutlinedIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            You don’t have permission to view this page.
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default PermissionDenied;
